<app-programtitle title="Find whether a given character is an alphabet"></app-programtitle>
<p> Write a program to find whether a given character is an alphabet or not. The non-alphabet characters are numbers, special characters etc.</p>
<app-editor code="{{program}}"> </app-editor>